module.exports = __webpack_public_path__ + "img/share.9f4bbc83.svg";